import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-view-jobs-for-company')) {
  var companyId = document.getElementById('react-component-g4-logistics-portal-view-jobs-for-company').getAttribute('data-company-id');
  ReactDOM.render(<JobsTable
      url = {"/api/v1/portal/jobs/company/"+companyId}
      infiniteScroll={true}
      message_if_none = 'Jobs not found or available for viewing.'
    />,

    document.getElementById('react-component-g4-logistics-portal-view-jobs-for-company'));
}
